"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.hlaTypingMessages = exports.statusByNephrologistMessages = exports.HlaTyping = exports.StatusByNephrologist = void 0;
const schema_1 = require("../../schema");
var StatusByNephrologist;
(function (StatusByNephrologist) {
    StatusByNephrologist["TRANSPLANTABLE"] = "TRANSPLANTABLE";
    StatusByNephrologist["NOT_TRANSPLANTABLE"] = "NOT_TRANSPLANTABLE";
})(StatusByNephrologist || (exports.StatusByNephrologist = StatusByNephrologist = {}));
var HlaTyping;
(function (HlaTyping) {
    HlaTyping["FIRST_SAMPLE_SENT"] = "FIRST_SAMPLE_SENT";
    HlaTyping["SECOND_SAMPLE_SENT"] = "SECOND_SAMPLE_SENT";
})(HlaTyping || (exports.HlaTyping = HlaTyping = {}));
exports.statusByNephrologistMessages = {
    [StatusByNephrologist.TRANSPLANTABLE]: {
        id: "ktx.patientCondition.statusByNephrologist.TRANSPLANTABLE",
        defaultMessage: "Transzplantálható"
    },
    [StatusByNephrologist.NOT_TRANSPLANTABLE]: {
        id: "ktx.patientCondition.statusByNephrologist.NOT_TRANSPLANTABLE",
        defaultMessage: "Nem Transzplantálható"
    }
};
exports.hlaTypingMessages = {
    [HlaTyping.FIRST_SAMPLE_SENT]: {
        id: "ktx.patientCondition.hlaTyping.FIRST_SAMPLE_SENT",
        defaultMessage: "Első minta elküldve"
    },
    [HlaTyping.SECOND_SAMPLE_SENT]: {
        id: "ktx.patientCondition.hlaTyping.SECOND_SAMPLE_SENT",
        defaultMessage: "Második minta elküldve"
    }
};
const description = schema_1.Schema.string().maxLength(10000);
const statusByNephrologist = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(StatusByNephrologist.TRANSPLANTABLE),
    schema_1.Schema.singleChoiceItem(StatusByNephrologist.NOT_TRANSPLANTABLE)
])
    .optional()
    .interpretation({ vocab: "ktx", code: "patient_status_by_nephrologist" });
const hlaTyping = schema_1.Schema.multiChoice([
    schema_1.Schema.multiChoiceItem(HlaTyping.FIRST_SAMPLE_SENT),
    schema_1.Schema.multiChoiceItem(HlaTyping.SECOND_SAMPLE_SENT)
]).optional();
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ description, statusByNephrologist, hlaTyping })
    .interpretation({ vocab: "ktx", code: "patient_condition_statement" });
